var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "body", locale: _vm.$root.$i18n.locale } },
    [
      _vm.codeVerified
        ? _c(
            "div",
            [
              _c("lenderSidebar", {
                attrs: { loading: _vm.loading, "agent-details": _vm.agent },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "side-right offset-lg-2",
                  attrs: { id: "page" },
                },
                [
                  _vm.loading
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column col-auto px-md-5",
                          style: { position: "fixed", top: "10%" },
                        },
                        [
                          _c("b-skeleton", {
                            attrs: { width: "30rem", height: "3rem" },
                          }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            attrs: { width: "40rem", height: "1rem" },
                          }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "mt-4",
                            attrs: {
                              width: "50rem",
                              height: "20rem",
                              speed: "2",
                              "primary-color": "#f3f3f3",
                              "secondary-color": "#ecebeb",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("guestLender", {
                        attrs: {
                          "generic-application-data":
                            _vm.genericApplicationData,
                          "url-id": _vm.urlId,
                          loading: _vm.loading,
                        },
                      }),
                ],
                1
              ),
            ],
            1
          )
        : _c("lender-code-verification-page", {
            attrs: {
              loading: _vm.verifyingCode,
              "code-verified": _vm.codeVerified,
            },
            on: { "verify-lender-code": _vm.verifyLenderCode },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }